import { graphql } from 'src/graphql';

export const NewFeatureNotifications = graphql(`
  query NewFeatureNotifications($is_active: Boolean, $limit: Int, $created_after: Float) {
    newFeatureNotifications(is_active: $is_active, limit: $limit, created_after: $created_after) {
      nodes {
        _id
        title
        link
        created
      }
      featured {
        _id
        title
        description
        link
        color
        img_path
      }
    }
  }
`);
